import React from 'react';
import * as dates from '@simplybenefits/sb-dates';
import Table from '@mui/material/Table/Table';
import TableHead from '@mui/material/TableHead/TableHead';
import TableRow from '@mui/material/TableRow/TableRow';
import TableCell from '@mui/material/TableCell/TableCell';
import TableBody from '@mui/material/TableBody/TableBody';
import PropTypes from 'prop-types';
import { Theme } from "@simplybenefits/sb-ui-library";
import { helpers } from '@simplybenefits/sb-utils';
import { useTheme } from '@mui/material/styles';

/**
 * @param value
 * @param field
 * @private
 */
function _getValue(value, field) {
    if (field === 'Shares') {
        return `${ Number(value).toFixed(2) }%`;
    }

    if (field === 'Salary' || field === 'Hourly Wage') {
        return `$${ helpers.numberWithCommasDecimals(Number(value)) }`;
    }

    if (field === 'Birth Date' || field === 'Hire Date') {
        return dates.getStartOfDay(value, 'll');
    }

    return value;
}

/**
 * @param report
 * @param classes
 * @returns {*}
 * @constructor
 */
const JourneyTable = ({ journey, meta }) => {
    const theme = useTheme();
    const styles = {
        table: {
            display: 'block',
            overflowX: 'auto',
            paddingBottom: '20px',
            width: '100%',
            border: "2px solid #F1F1F1",
            backgroundColor: '#FFF'
        },
        scrollbar: {
            '&::webkitScrollbar': {
                height: '15px',
                width: '15px'
            },
            '&::webkitSrollbarThumb': {
                backgroundColor: Theme.colors.surface,
                borderRadius: '10px',
                boxShadow: 'inset 0 0 2px rgba(0, 0, 0, .5)'
            },
            '&::webkitScrollbarTrack': {
                backgroundColor: Theme.colors.backgroundGrey,
                borderRadius: '10px',
                boxShadow: 'inset 0 0 2px rgba(0, 0, 0, 0.2)'
            }
        },
        tableHeading: {
            paddingTop: "10px",
            paddingBottom: "10px",
            paddingRight: "2vw",
            paddingLeft: "2vw",
            fontFamily: Theme.fonts.type.heading,
            color: Theme.colors.surface,
            whiteSpace: "nowrap",
            border: "none"
        },
        tableCell: {
            paddingTop: "10px",
            paddingBottom: "10px",
            fontFamily: Theme.fonts.type.light,
            whiteSpace: "nowrap",
            paddingRight: "2vw",
            paddingLeft: "2vw",
            color: Theme.colors.mainTextGrey
        },
        container: {
            flex: 1,
            border: "2px solid #F1F1F1",
            borderRadius: 5,
            backgroundColor: '#FFF',
            padding: 20
        }
    };
    return (
        <div style={ styles.container }>
            <div style={{ overflow: "auto", maxHeight: 600, ...styles.scrollbar }}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: theme.palette.primary.main }}>
                            <TableCell style={styles.tableHeading}>
                            Type
                            </TableCell>

                            <TableCell style={styles.tableHeading}>
                            User
                            </TableCell>

                            <TableCell style={styles.tableHeading}>
                            Field
                            </TableCell>

                            <TableCell style={styles.tableHeading}>
                            Old Value
                            </TableCell>

                            <TableCell style={styles.tableHeading}>
                            New Value
                            </TableCell>

                            <TableCell style={styles.tableHeading}>
                            Changed By
                            </TableCell>

                            <TableCell style={styles.tableHeading}>
                            Date of Change
                            </TableCell>

                            <TableCell style={styles.tableHeading}>
                            Effective Date
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {
                            journey.map((item, index) => {
                                let backgroundObject = { border: "none" };
                                if (index % 2 !== 0) {
                                    backgroundObject = { backgroundColor: Theme.colors.backgroundGrey, border: "none" };
                                }

                                return (
                                    <TableRow key={`${ item.type } ${ item.occurred }`}>
                                        <TableCell style={{ ...styles.tableCell, ...backgroundObject }}>
                                            { item.type }
                                        </TableCell>

                                        <TableCell style={{ ...styles.tableCell, ...backgroundObject }}>
                                            { item.entityLabel || `${ meta.firstname } ${ meta.lastname }` }
                                        </TableCell>

                                        <TableCell style={{ ...styles.tableCell, ...backgroundObject }}>
                                            { item.field || 'N/A' }
                                        </TableCell>

                                        <TableCell style={{ ...styles.tableCell, ...backgroundObject }}>
                                            { item.oldValue ? _getValue(item.oldValue, item.field) : 'N/A' }
                                        </TableCell>

                                        <TableCell style={{ ...styles.tableCell, ...backgroundObject }}>
                                            { item.newValue ? _getValue(item.newValue, item.field) : 'N/A' }
                                        </TableCell>

                                        <TableCell style={{ ...styles.tableCell, ...backgroundObject }}>
                                            { item.changedBy }
                                        </TableCell>

                                        <TableCell style={{ ...styles.tableCell, ...backgroundObject }}>
                                            { dates.getLocalDisplay(item.occurred, 'lll') }
                                        </TableCell>

                                        <TableCell style={{ ...styles.tableCell, ...backgroundObject }}>
                                            { dates.getUTC(item.effectiveDate, 'll') }
                                        </TableCell>
                                    </TableRow>
                                );
                            })
                        }
                    </TableBody>
                </Table>
            </div>
        </div>
    );
};


JourneyTable.propTypes = {
    report: PropTypes.array
};

export default (JourneyTable);